/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner } from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner';
import {
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSONTyped,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSON,
} from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner';
import type { MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner } from './MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner';
import {
    MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSON,
    MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped,
    MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerToJSON,
} from './MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner';
import type { MatrixCarePatientDetailsDocumentsScreenerDocumentsInner } from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInner';
import {
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSONTyped,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerToJSON,
} from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInner';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocuments
 */
export interface MatrixCarePatientDetailsDocuments {
    /**
     * 
     * @type {Array<MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner>}
     * @memberof MatrixCarePatientDetailsDocuments
     */
    generated_documents?: Array<MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner>;
    /**
     * 
     * @type {Array<MatrixCarePatientDetailsDocumentsScreenerDocumentsInner>}
     * @memberof MatrixCarePatientDetailsDocuments
     */
    screener_documents?: Array<MatrixCarePatientDetailsDocumentsScreenerDocumentsInner>;
    /**
     * 
     * @type {Array<CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner>}
     * @memberof MatrixCarePatientDetailsDocuments
     */
    additional_documents?: Array<CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner>;
}

/**
 * Check if a given object implements the MatrixCarePatientDetailsDocuments interface.
 */
export function instanceOfMatrixCarePatientDetailsDocuments(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MatrixCarePatientDetailsDocumentsFromJSON(json: any): MatrixCarePatientDetailsDocuments {
    return MatrixCarePatientDetailsDocumentsFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocuments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'generated_documents': !exists(json, 'generated_documents') ? undefined : ((json['generated_documents'] as Array<any>).map(MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSON)),
        'screener_documents': !exists(json, 'screener_documents') ? undefined : ((json['screener_documents'] as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSON)),
        'additional_documents': !exists(json, 'additional_documents') ? undefined : ((json['additional_documents'] as Array<any>).map(CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSON)),
    };
}

export function MatrixCarePatientDetailsDocumentsToJSON(value?: MatrixCarePatientDetailsDocuments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'generated_documents': value.generated_documents === undefined ? undefined : ((value.generated_documents as Array<any>).map(MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerToJSON)),
        'screener_documents': value.screener_documents === undefined ? undefined : ((value.screener_documents as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerToJSON)),
        'additional_documents': value.additional_documents === undefined ? undefined : ((value.additional_documents as Array<any>).map(CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSON)),
    };
}

